<template>
  <v-container text-xs-center class="coverImg mx-0 px-0">
    <v-row align=center class="mx-0 mt-0 pt-0 pt-0 mb-5">
      <v-col cols=1>
      <v-btn icon class="white--text" v-if="getUser!=null" @click="logout">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      </v-col>
      <v-col cols=5>
        <span class="white--text" v-if="getUser!=null">{{$t("welcome")}}</span>
      </v-col>
      <v-col cols=4>
      </v-col>
      <v-col cols=1>
        <changeLocaleBtn :loginPage="true" />
      </v-col>
    </v-row>
    <v-row class="colorlogin" justify="center">
    </v-row>

    <v-row justify="center" class="mx-0 mt-0 pt-0 pt-0 pb-0">
      <v-col v-on:keyup.enter="login" sm="12" class="mx-0 mt-1 mb-5 pt-0 pb-0">
        <v-text-field  :hide-details="true" outlined :label="$t('userName')" required v-model="username" name="username" id="username">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center" class="mx-0 mt-0 pt-0 pb-0">
      <v-col v-on:keyup.enter="login" sm="12" class="mx-0 mt-0 pt-0 pb-0">
        <v-text-field :hide-details="true" outlined id="password" name="password" v-model="password" :label="$t('password')"
          :append-icon="value ? 'visibility' : 'visibility_off'" @click:append="() => (value = !value)"
          :type="value ? 'password' : 'text'">
          <!--v-icon slot="prepend" color="primary">
            mdi-lock
          </v-icon-->
        </v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center" class="mx-0">
      <v-col v-on:keyup.enter="login" sm="12" class="mx-0 pt-0 pb-0">
        <!--TODO save credentials-->
        <v-checkbox class="text--white" color="primary" dark v-model="haveToSaveCredentials" :label="$t('rememberMe')"></v-checkbox>
      </v-col>
    </v-row>
    <v-row justify="center" class="mx-0">
      <v-col v-on:keyup.enter="login" align="left" cols="12" class="mx-0 pt-0 pb-0 ">
        <v-checkbox color="primary" dark ref="checkboxTermsandconditions" @click="onChangePublicScope"
          v-model="termsandcondition" :label="$t('IAgreeWithTermsAndConditionsTitle')"></v-checkbox>
      </v-col>
    </v-row>
    <v-row justify="center" class="mx-1 mt-1">
      <v-col lg="12" sm="12" align="center" class="mx-1 mt-0">
        <v-btn class="btn1 px-4 pt-3 pb-3" :disabled="!termsandcondition" @click.prevent="login()"
          type="submit" id="Login">
          {{$t('loginAuthor')}}</v-btn>
      </v-col>
       </v-row>

<div class="whiteFooter">

</div>
    <v-row style="position:absolute;bottom:0px;height:30vh;z-indez:2;width:100vw;max-width: 700px;" align="center" justify="center" class="mx-0 mt-3 mb-3">
      <v-col align="center" cols=12>
        {{$t('youDontHaveCredentials')}}
      </v-col>
      <v-col cols=12 lg="12" xs="12" align="center" class="mx-3 mt-0">
        <v-btn  class="btn1 px-5 pt-5 pb-5" color="secondaryVariant" :disabled="!termsandcondition"
          @click.prevent="loginAsGuest" type="submit" id="Login">
          {{$t('viewStories')}}</v-btn>
      </v-col>
            <v-col align="center" cols="6" class="mx-0  px-0 pt-0 pb-0">
        <v-tooltip color="primaryVariant" v-model="isTooltipOpen" top v-if="termsandcondition!=true">
          <template v-slot:activator="{ on, attrs }">

            <div v-bind="attrs" v-on="on">
              <v-btn class="px-0 mx-0 text-capitalize fontsize" text @click="gotopage('termsAndConditions')">
                {{$t('termsAndConditionsTitle')}}

              </v-btn>
            </div>
          </template>
          <span>{{$t('PleaseAgreeTermsAndCondition')}}</span>
        </v-tooltip>
        <v-btn v-else class="text-capitalize fontsize " text @click="gotopage('termsAndConditions')">
          {{$t('termsAndConditionsTitle')}}

        </v-btn>

      </v-col>

      <v-col col=6 class="mx-0 px-0 pt-0 pb-0 fontsize text-right pr-0">
        <privacyPolicies />
      </v-col>

    </v-row>
      </v-container>
</template>

<script>

import privacyPolicies from "@/components/privacyPolicies";
import changeLocaleBtn from "@/components/changeLanguageBtn";

export default {
  name: "Login",
  data() {
    return {
      termsandcondition:false,
      isTooltipOpen:true,
      value: String,
      haveToSaveCredentials:false,
      selectedRoleValue: null,
      allRoles: [],
      apiUrl: process.env.VUE_APP_ROOT_API,
      username: "",
      password: "",
      submitted: false
    };
  },
  components:{
    privacyPolicies,
    changeLocaleBtn
  },
async mounted() {
this.termsandcondition=this.$store.state.isTermsAndCondition
//    if (this.getUser==null){
//      this.$router.push("loginFirstTime")
//    }

  this.getBrowserLanguage()
  /*if(this.termsandcondition){
  this.$refs.checkboxTermsandconditions.internalValue = this.termsandcondition
  this.$refs.checkboxTermsandconditions.value = this.termsandcondition
  this.$refs.checkboxTermsandconditions.lazyValue = this.termsandcondition

  }*/
      await setTimeout(()=>{this.isTooltipOpen=false}, 5000)

  },

  computed: {
    getUser: {
      get: function () {
        if (this.$store.getters.getUser){
          return this.$store.getters.getUser;
        }
        return null;
      }
    }
  },
  methods: {
    onChangePublicScope() {
  this.$store.dispatch('setTermsAndCondition', !this.termsandcondition)
  //this.termsandcondition = this.$store.getters.getTermsAndCondition
},
    logout: function() {
      this.$store
        .dispatch("logout", null).then(()=> this.$router.push({'name':"splashScreen"}))
    },
        getBrowserLanguage: function () {
      switch(navigator.language) {
  case "it-IT":
    this.setLocale("it")// code block
    break;
  case "es-ES":
        this.setLocale("es")// code block
// code block
    break;
    case "ca":
     this.setLocale("cat") //code block
      break;
        case "fr":
     this.setLocale("fr")// code block
    break;
  default:
    this.setLocale("en")
   //en-GB
    // code block
      }
    //console.log(navigator.language)
    },
    setLocale(selectedLanguage) {
        this.$store.dispatch("setPreferredLanguage", selectedLanguage)
        this.$i18n.locale = selectedLanguage;
        this.$vuetify.lang.current = selectedLanguage;
    },
    //change the page
    gotopage: function (page) {
      this.$router.push(page)
    },
    selectedRole(selectedItems) {
      this.selectedRoleValue = selectedItems;
    },
    login: function() {
      this.error = "";
  //    EventBus.$emit("spinner", "on");
        this.$store.dispatch('setLoading',true)

      this.$axios
        .post(this.apiUrl + "/login", {
          user: this.username.toLowerCase(),
          password: this.password
        })
        .then(response => {
          // Handle success.
          if (response.status === 200) {
            this.$store.dispatch("setIsJourneyOrSingleStory", false)
            this.$store.dispatch("setSuggestionSearchText", '')
            this.$store.dispatch("setIsToggleSuggestionEnable", false)
            this.$store.dispatch('setIsSuggestionLoading',false)
            this.submitted = true;
            response.data.location_id;
            this.$store
              .dispatch("setAccessToken", response.data.jwt)
              .then(()=> this.$store.dispatch("setUser", response.data.user))
              .then(()=> this.$store.dispatch("setPreferredLanguage", response.data.user.language))
              .then(()=> this.$store.dispatch("setUserInfoStoredinLocalStorage",this.haveToSaveCredentials))
              .then(()=>this.$store.dispatch("increaseUserLoginCounter"))
              .then(()=> this.$store.dispatch('setLoading',false))

              .then(()=>this.$store.dispatch('setIsCreatedOrviewStories',1))
              .then(()=>this.$store.dispatch('setIsAllOrNearme',0))
              
              .then(()=> this.$router.push('home'));
          }
        })
        .catch(error => {
          if (error.status === 400) {

            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: this.$t('loginIncorrectCredentials'),
              active: true
            })
            //EventBus.$emit("spinner", "off");
          }
          // Handle error.
          else {
            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: this.$t('loginIncorrectCredentials'),
              active: true
            })
           // EventBus.$emit("spinner", "off");
            // eslint-disable-next-line
            console.log(error);
          }
        });
    },
    loginAsGuest: function() {
      this.error = "";
  //    EventBus.$emit("spinner", "on");
        this.$store.dispatch('setLoading',true)

      this.$axios
        .post(this.apiUrl + "/login", {
          user: 'Guest',
          password: 'GuestGuest'
        })
        .then(response => {
          // Handle success.
          if (response.status === 200) {
            this.submitted = true;
            response.data.location_id;
            this.$store
              .dispatch("setAccessToken", response.data.jwt)
              .then(()=> this.$store.dispatch("setUser", response.data.user))
              .then(()=> this.$store.dispatch("setPreferredLanguage", response.data.user.language))
              .then(()=> this.$store.dispatch("setUserInfoStoredinLocalStorage",this.haveToSaveCredentials))
              .then(()=>this.$store.dispatch("increaseUserLoginCounter"))
              .then(()=> this.$store.dispatch('setLoading',false))

              .then(()=>this.$store.dispatch('setIsCreatedOrviewStories',1))
              .then(()=>this.$store.dispatch('setIsAllOrNearme',0))

              .then(()=> this.$router.push('home'));
          }
        })
        .catch(error => {
          if (error.status === 400) {

            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: this.$t('loginIncorrectCredentials'),
              active: true
            })
            //EventBus.$emit("spinner", "off");
          }
          // Handle error.
          else {
            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: this.$t('loginIncorrectCredentials'),
              active: true
            })
           // EventBus.$emit("spinner", "off");
            // eslint-disable-next-line
            console.log(error);
          }
        });
    }
  }
};
</script>
<style>
body{
      min-height:700px;
}
.fontsize{
  font-size: 0.75rem!important;
  white-space: nowrap!important;
}
.btn1{
  padding:auto 1rem;
  border-radius:999rem;
  text-transform: initial;
width: 240px;
}
.whiteFooter{
background-color:white;
opacity: 0.4;
position:absolute;
bottom:0px;
left:0px;
width:100%;
max-width: 700px;
margin:0px;
height:30vh;
z-index: 0;

}
.coverImg{
  background: url('~@/assets/loginscreen.png') no-repeat center center fixed;
    -webkit-background-size: cover;
   -moz-background-size: cover;
   -o-background-size: cover;
   background-size: cover;
    height: 100vh;
    min-height: 620px;
}
.colorlogin{
  background-color: lightgray;
}
.loginbtn{
  text-transform: initial;
  border-radius: 999px;

}

.v-input.v-input--hide-details.theme--light.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined{
  border-radius: 999rem!important;
}

</style>
